export const roles = {
   ADMIN: "ADMIN",
   PARTNER: "PARTNER",
   CUSTOMER: "CUSTOMER",
}
